module.exports = __webpack_public_path__ + "static/TnT-805b262538d252238eb9ce22905f80e1.png";